// GA4, Meta Pixel e TikTok Pixel: attivi solo se gli ID sono presenti nelle variabili d'ambiente.
// Aggiungere REACT_APP_GA4_ID, REACT_APP_META_PIXEL_ID, REACT_APP_TIKTOK_PIXEL_ID in frontend/.env per attivarli.

export const initAnalytics = () => {
  const ga4Id = process.env.REACT_APP_GA4_ID;
  const metaId = process.env.REACT_APP_META_PIXEL_ID;
  const tiktokId = process.env.REACT_APP_TIKTOK_PIXEL_ID;

  if (ga4Id) {
    const s = document.createElement("script");
    s.async = true;
    s.src = `https://www.googletagmanager.com/gtag/js?id=${ga4Id}`;
    document.head.appendChild(s);
    window.dataLayer = window.dataLayer || [];
    window.gtag = function () {
      window.dataLayer.push(arguments);
    };
    window.gtag("js", new Date());
    window.gtag("config", ga4Id);
  }

  if (metaId && !window.fbq) {
    const n = (window.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    });
    n.queue = [];
    n.loaded = true;
    n.version = "2.0";
    const s = document.createElement("script");
    s.async = true;
    s.src = "https://connect.facebook.net/en_US/fbevents.js";
    document.head.appendChild(s);
    window.fbq("init", metaId);
    window.fbq("track", "PageView");
  }

  if (tiktokId && !window.ttq) {
    const t = (window.ttq = window.ttq || []);
    t.methods = ["page", "track"];
    const s = document.createElement("script");
    s.async = true;
    s.src = "https://analytics.tiktok.com/i18n/pixel/events.js";
    document.head.appendChild(s);
    window.ttq.load && window.ttq.load(tiktokId);
    window.ttq.page && window.ttq.page();
  }
};

export const trackEvent = (name, params = {}) => {
  if (window.gtag) window.gtag("event", name, params);
  if (window.fbq) window.fbq("trackCustom", name, params);
};
